// extracted by mini-css-extract-plugin
module.exports = {"LeftSidebar":"LeftSidebar_LeftSidebar__2DRxs"};